export default {
  LIST_FETCHED: 'PARTICIPANTS_FETCHED',
  STATUS_UPDATE: 'PARTICIPANTS_STATUS_UPDATE',
  ITEM_DETAIL: 'PARTICIPANTS_DETAIL',
  BUTTON_LOAD: 'PARTICIPANTS_BUTTON_LOAD',
};
